var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinebar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 76,
    viewBox: "0 0 103 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 18,
    transform: "matrix(-1 0 0 1 89 58)",
    fill: "#496DFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 9,
    transform: "matrix(-1 0 0 1 61 67)",
    fill: "#496DFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    transform: "matrix(-1 0 0 1 80 72)",
    fill: "#496DFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 44,
    width: 8,
    height: 32,
    fill: "#496DFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 17,
    transform: "matrix(-1 0 0 1 52 59)",
    fill: "#496DFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 31,
    transform: "matrix(-1 0 0 1 70 45)",
    fill: "#496DFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 53,
    width: 10,
    height: 23,
    fill: "#496DFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 19,
    width: 8,
    height: 57,
    fill: "#496DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.2857L7.83495 12.5714L14.5146 28.8571L21.0388 4H27.7184L34.3981 43.8571L41.3884 26.2857L47.6019 30.3571L54.2816 49L61.4272 37.2143L67.6408 12.5714L74.6311 30.3571L81.1553 4L87.835 26.2857L94.5146 33.7857L101.194 24.3571L100.737 25.0019",
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinebar);
export default __webpack_public_path__ + "static/media/linebar.c124b20cecc62eb60765ae250319afbc.svg";
export { ForwardRef as ReactComponent };